export const timezoneOptions = [
  { value: 'America/New_York', label: 'Eastern Time (New York)' },
  { value: 'America/Detroit', label: 'Eastern Time (Detroit)' },
  {
    value: 'America/Kentucky/Louisville',
    label: 'Eastern Time (Louisville)',
  },
  {
    value: 'America/Kentucky/Monticello',
    label: 'Eastern Time (Monticello)',
  },
  {
    value: 'America/Indiana/Indianapolis',
    label: 'Eastern Time (Indianapolis)',
  },
  { value: 'America/Indiana/Vincennes', label: 'Eastern Time (Vincennes)' },
  { value: 'America/Indiana/Winamac', label: 'Eastern Time (Winamac)' },
  { value: 'America/Indiana/Marengo', label: 'Eastern Time (Marengo)' },
  { value: 'America/Indiana/Petersburg', label: 'Eastern Time (Petersburg)' },
  { value: 'America/Indiana/Vevay', label: 'Eastern Time (Vevay)' },

  { value: 'America/Chicago', label: 'Central Time (Chicago)' },
  { value: 'America/Indiana/Knox', label: 'Central Time (Knox)' },
  { value: 'America/Indiana/Tell_City', label: 'Central Time (Tell City)' },
  { value: 'America/Menominee', label: 'Central Time (Menominee)' },
  {
    value: 'America/North_Dakota/Center',
    label: 'Central Time (Center, ND)',
  },
  {
    value: 'America/North_Dakota/New_Salem',
    label: 'Central Time (New Salem, ND)',
  },
  {
    value: 'America/North_Dakota/Beulah',
    label: 'Central Time (Beulah, ND)',
  },

  { value: 'America/Denver', label: 'Mountain Time (Denver)' },
  { value: 'America/Boise', label: 'Mountain Time (Boise)' },
  { value: 'America/Phoenix', label: 'Mountain (no DST - Phoenix)' },

  { value: 'America/Los_Angeles', label: 'Pacific Time (Los Angeles)' },
  { value: 'America/Metlakatla', label: 'Alaska Time (Metlakatla)' },
  { value: 'America/Anchorage', label: 'Alaska Time (Anchorage)' },
  { value: 'America/Juneau', label: 'Alaska Time (Juneau)' },
  { value: 'America/Nome', label: 'Alaska Time (Nome)' },
  { value: 'America/Sitka', label: 'Alaska Time (Sitka)' },
  { value: 'America/Yakutat', label: 'Alaska Time (Yakutat)' },

  { value: 'America/Adak', label: 'Hawaii–Aleutian Time (Adak)' },
  { value: 'Pacific/Honolulu', label: 'Hawaii Time (Honolulu)' },

  { value: 'Pacific/Midway', label: 'Samoa Time (Midway Atoll)' },
  { value: 'Pacific/Pago_Pago', label: 'Samoa Time (American Samoa)' },

  { value: 'Pacific/Guam', label: 'Chamorro Time (Guam)' },
  { value: 'Pacific/Saipan', label: 'Chamorro Time (Saipan)' }, // ← added
  { value: 'Pacific/Wake', label: 'Wake Island Time' }, // ← added
  // { value: "Pacific/Johnston", label: "Hawaii Time (Johnston Atoll)" }, // optional alias

  { value: 'Pacific/Chuuk', label: 'Chuuk Time (Micronesia)' },
  { value: 'Pacific/Yap', label: 'Yap Time (Micronesia)' },
  { value: 'Pacific/Palau', label: 'Palau Time' },

  { value: 'America/Puerto_Rico', label: 'Atlantic Time (Puerto Rico)' },
  {
    value: 'America/Port_of_Spain',
    label: 'Atlantic Time (Trinidad & Tobago)',
  },
  {
    value: 'America/St_Thomas',
    label: 'Atlantic Time (U.S. Virgin Islands)',
  },
];
